import { PetType } from 'constants/pet-type';
import {
  AllergySegmentationIds,
  CatAllergySegmentationIds,
  CatNutritionSegmentationIds,
  NutritionSegmentationIds,
} from 'constants/segmentation';
import { useMemo } from 'react';

/**
 * Hook that filters and returns the available needs based on the active pet type
 * and excludes certain needs like Disease, Foodaid and NoHelpNeeded
 */
export const useFilteredNeeds = ({
  petType,
}: {
  petType: (typeof PetType)[keyof typeof PetType];
}) => {
  const allergyEntries = Object.entries(
    petType === PetType.Dog ? AllergySegmentationIds : CatAllergySegmentationIds
  );

  const filteredNeedsEntries = useMemo(() => {
    const needsEntries =
      petType === PetType.Dog
        ? NutritionSegmentationIds
        : CatNutritionSegmentationIds;

    return Object.entries(needsEntries).filter(
      ([, value]) =>
        value !== CatNutritionSegmentationIds.DiseaseCat &&
        value !== NutritionSegmentationIds.Disease &&
        value !== NutritionSegmentationIds.Foodaid &&
        value !== NutritionSegmentationIds.NoHelpNeeded
    );
  }, [petType]);

  return { allergyEntries, filteredNeedsEntries };
};
